import { post } from '../utility';

export const search = ({ callback }) => {
	post({
		method: 'supportedDocument.search',
		params: {},
		callback,
	});
};
